const Counter = ({clicks}) => {

    return (
        <div className="Counter">
            {clicks}
        </div>
    );
}

export default Counter;

